export default {"src":"/_next/static/media/computerIcon.96bea14b.svg","height":18,"width":18};